import { MaterialRequest } from "../../../data/entities";
import { SingleMaterialContentWrapper } from "./Styled";
import { DoubleColumnWrapper, SecondColumn } from "../Styled";
import { MaterialList } from "./MaterialList";
import Priority from "../../ProductOrder/single/Priority";
import apiMethods from "../../../utils/api";
import { MATERIAL_REQUEST_STATUS } from "../../../data/enums";
import Note from "../../../shared/components/Note";
import { Assignees } from "./Assignees";
import Upload from "./Upload";
import { SaleOrderLink } from "./SaleOrderLink";

interface SingleMaterialRequestProps {
    materialRequest: MaterialRequest;
    mergeMaterialRequest: Function;
    fetchMaterialRequest?: any;
    isView?: boolean;
    useOtherMaterials?: boolean;
}

export const SingleMaterialRequest = ({
                                          materialRequest,
                                          mergeMaterialRequest,
                                          fetchMaterialRequest,
                                          isView,
                                          useOtherMaterials,
                                      }: SingleMaterialRequestProps) => {
    const updateMaterialRequest = async (data: any) => {
        // await apiMethods.patch(`/materials/order/${materialRequest?.id}/`, data);
        await apiMethods.patch(`/materials/requests/${materialRequest?.id}/`, data);
    };

    const assigneeCases = () => {
        const requiredStorageKeepers = materialRequest.required_storage_keepers || [];

        const storageKeeperAssignments: any[] = [];

        requiredStorageKeepers.forEach((keeper) => {
            if (keeper === "first_storage_keeper") {
                storageKeeperAssignments.push({
                    title: "Thủ kho 1",
                    fieldName: "first_storage_keeper",
                    role: "first_storage_keeper",
                });
            }
            if (keeper === "second_storage_keeper") {
                storageKeeperAssignments.push({
                    title: "Thủ kho 2",
                    fieldName: "second_storage_keeper",
                    role: "second_storage_keeper",
                });
            }
        });

        switch (materialRequest.status) {
            case MATERIAL_REQUEST_STATUS.OPEN:
            case MATERIAL_REQUEST_STATUS.EXPORTING:
            case MATERIAL_REQUEST_STATUS.COMPLETED:
                return [
                    {
                        title: "Quản đốc xưởng/ Phó quản đốc xưởng",
                        fieldName: "factory_manager",
                        role: "factory_manager",
                    },
                    ...storageKeeperAssignments,
                ];
            default:
                return [];
        }
    };

    return (
        <SingleMaterialContentWrapper>
            {materialRequest.id && (
                <SaleOrderLink
                    saleOrders={materialRequest.sale_orders || []}
                    requestedProducts={(materialRequest as any).requested_products || []}
                />
            )}

            <MaterialList
                materials={materialRequest.materials as any}
                mergeMaterialRequest={mergeMaterialRequest}
                isView={isView}
                useOtherMaterials={useOtherMaterials}
            />

            <DoubleColumnWrapper>
                <SecondColumn>
                    {materialRequest.id && (
                        <Upload materialRequestId={materialRequest.id} />
                    )}
                </SecondColumn>
                <SecondColumn>
                    {isView ? (
                        <Assignees
                            data={materialRequest}
                            updateData={updateMaterialRequest}
                            fetchData={fetchMaterialRequest}
                            mergeMaterialRequest={mergeMaterialRequest}
                            fields={assigneeCases()}
                        />
                    ) : (
                        <Priority
                            productOrder={materialRequest as any}
                            mergeProductOrder={mergeMaterialRequest as any}
                        />
                    )}
                    <Note
                        text={materialRequest.note}
                        setText={(value: string) => mergeMaterialRequest({ note: value })}
                        isView={isView}
                        compact
                    />
                </SecondColumn>
            </DoubleColumnWrapper>
        </SingleMaterialContentWrapper>
    );
};
